// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuesax from 'vuesax'
import Meta from 'vue-meta'
import App from './App'
import store from './store'
import router from './router'
import config from './store/config.js'
import axios from 'axios'
import moment from 'moment'
import ElementUI from 'element-ui'
import Firestore from 'vue-firestore'
import VueAnalytics from 'vue-analytics'

// css
import theme from './style/theme.js'
import 'vuesax/dist/vuesax.css'
import 'material-icons/iconfont/material-icons.css'

// ElementUI Customize - https://element.eleme.io/#/en-US/theme/preview
import './style/element_ui/theme/index.css'

// Vuesac Customize
Vue.use(Vuesax, {
  theme: {
    colors: {
      primary: theme.primaryColor,
      success: theme.successColor,
      danger: theme.warningColor,
      warning: theme.dangerColor,
      dark: theme.infoColor
    }
  }
})
Vue.use(Meta)
Vue.use(ElementUI)
Vue.use(Firestore)
Vue.use(VueAnalytics, {
  id: 'UA-151594285-2',
  router
})

Vue.config.productionTip = false

Vue.prototype.$http = axios
Vue.prototype.$config = config
Vue.prototype.$event = new Vue()
Vue.prototype.$theme = theme
Vue.prototype.$log = {
  i: function() { console.log.apply(console, arguments) },
  d: function() { if (store.state.isDev) console.log.apply(console, arguments) },
  w: function() { console.log.apply(console, arguments) }
}
Vue.prototype.$eventList = {
  markerSelected: 'markerSelected',
  markerStateLoaded: 'markerStateLoaded',
  mapLoaded: 'mapLoaded',
  mapDataLoaded: 'mapDataLoaded',
  isProjectOwner: 'isProjectOwner',
  teamsNum: 'teamsNum',
  showSidebar: 'showSidebar',
  selectedTeamIndex: 'selectedTeamIndex',
  showModifyDialog: 'showModifyDialog',
  showSelectHeaderDialog: 'showSelectHeaderDialog'
}

/* filter */
Vue.filter('dateFormat', (date, format) => {
  return moment(date).format(format)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js